import { color, typography } from '@gyym/ui'
import styled from 'styled-components'

export const ResultCount = styled.div`
  ${typography('catch')}
  /* height: 51px; */
  color: ${color('gray.01')};
`

export const ResultCountContainer = styled.div`
  display: flex;
  /* Same height as the loading */
  height: 100px;
`
